module.exports = __webpack_public_path__ + "static/media/02.ce9e0305.mp3";